import Drawer from '@material-ui/core/Drawer';
import React, {useEffect, useState} from 'react';
import {useMediaQuery} from 'react-responsive';
import {useRouter} from 'next/router';
import Image from 'next/image';
import useBrowser from '../../hooks/useBrowser';

function OpenAppBottomSheetComponent () {
	const router = useRouter();
	const {browserDetails} = useBrowser();
	const [showPromptForStoreLink, setShowPromptForStoreLink] = useState(false);

	useEffect(() => {
		console.log('strokeLink - ', router.query.store_link);
		if(router.query.store_link) {
			setShowPromptForStoreLink(true);
		}
	}, [router.query.store_link])

	return (
		<Drawer
			variant="temporary"
			open={showPromptForStoreLink}
			anchor={'bottom'}
			onClose={() => {
				setShowPromptForStoreLink(false);
				navigator && navigator.vibrate && navigator.vibrate(5);
			}}
			ModalProps={{keepMounted: true, closeAfterTransition: true}}
			className="app-browser-prompt"
		>
			<div className="app-browser-prompt-container">
				<div className="app-browser-prompt-header">
					<h2>Watch lecture in...</h2>
				</div>
				<div className="support-row">
					<div className="support-row-label">
						<Image src={require('../../public/assets/images/browsers/pustack_app.png')} alt="Pustack" />
						<span>PuStack App</span>
					</div>
					<button className='open-app' onClick={e => {
						router.query.store_link && window.open(router.query.store_link, '_blank');
						// setShowPromptForStoreLink(false);
					}}>Open</button>
				</div>
				<div className="support-row">
					<div className="support-row-label">
						<Image src={browserDetails['icon']} alt="Web Browser" />
						<span>Browser</span>
					</div>
					<button onClick={() => setShowPromptForStoreLink(false)}>Continue</button>
				</div>
			</div>
		</Drawer>
	)
}

export default function OpenAppBottomSheet() {
	const router = useRouter();
	const isMobileScreen = useMediaQuery({ query: "(max-width: 500px)" });
	const [showPromptForStoreLink, setShowPromptForStoreLink] = useState(false);

	useEffect(() => {
		if(router.query.store_link) {
			setShowPromptForStoreLink(true);
		}
	}, [router.query.store_link])

	return (
		isMobileScreen && showPromptForStoreLink ? <OpenAppBottomSheetComponent /> : null
	)
}
